var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditIcn = function SvgEditIcn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.14 8a.57.57 0 0 0-.57.57v5.72c0 .31-.25.57-.57.57H1.71a.57.57 0 0 1-.57-.57V2.86c0-.32.26-.57.57-.57h6.86a.57.57 0 1 0 0-1.15H1.71C.77 1.14 0 1.91 0 2.86v11.43C0 15.23.77 16 1.71 16H12c.95 0 1.71-.77 1.71-1.71V8.57a.57.57 0 0 0-.57-.57z",
    fill: "#7388AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.36.64a2.19 2.19 0 0 0-3.1 0L4.75 8.17a.58.58 0 0 0-.14.22l-1.14 3.43a.57.57 0 0 0 .72.72l3.43-1.14a.57.57 0 0 0 .22-.14l7.53-7.53c.85-.85.85-2.23 0-3.09zm-.8 2.29-7.44 7.43-2.22.74.74-2.22 7.43-7.43a1.05 1.05 0 0 1 1.48 1.48z",
    fill: "#7388AE"
  })));
};
export default SvgEditIcn;